module.exports = __webpack_public_path__ + "static/media/popular-6.a9b9997d.svg";